"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PubSub = (function () {
    function PubSub(channel) {
        this.channel = channel;
        this.listener = function () {
            return;
        };
    }
    PubSub.prototype.get = function () {
        return JSON.parse(localStorage.getItem(this.channel))[0];
    };
    PubSub.prototype.publish = function (data) {
        localStorage.setItem(this.channel, JSON.stringify([data, Date.now()]));
        this.listener(this.get());
    };
    PubSub.prototype.subscribe = function (listener) {
        var _this = this;
        this.listener = listener;
        window.addEventListener('storage', function (e) {
            if (e.key === _this.channel) {
                _this.listener(_this.get());
            }
        }, true);
    };
    return PubSub;
}());
exports.PubSub = PubSub;
